export enum ORDER_TYPE {
  LOOSE_PIECE_ORIGINAL = "LOOSE_PIECE_ORIGINAL",
  LOOSE_REP_ORIGINAL = "LOOSE_REP_ORIGINAL",
  SET_IMPORT = "SET_IMPORT",
  WITH_DASBOARD = "WITH_DASBOARD",
  SET_EXPORT = "SET_EXPORT",
  CAR = "CAR",
  INTERN = "INTERN",
}

export enum CUSTOMER_TYPE {
  PRIVATE = "private",
  COMPANY = "company",
}

export type CountryCode = string;

export enum DELIVERY_METHOD {
  COUNTER = "COUNTER",
  PICKUP = "PICKUP",
  SHIPPING = "SHIPPING",
  WORKSHOP = "WORKSHOP",
}

export enum PAYMENT_STATUS {
  NOT_PAID = "NOT_PAID",
  PAID = "PAID",
  CASH_ON_DELIVERY = "CASH_ON_DELIVERY",
}

export enum PAYMENT_METHOD {
  BANCONTACT = "BANCONTACT",
  CASH = "CASH",
  BANK_TRANSFER = "BANK_TRANSFER",
}

export enum REPAIR_STATUS {
  REGISTRATION = "REGISTRATION",
  UNPACKING = "UNPACKING",
  BOOKING = "BOOKING",
  WORKTABLE = "WORKTABLE",
  INSPECTION = "INSPECTION",
  READY = "READY",
  CLOSED = "CLOSED",
}

export enum ORDER_DASH_OPTION {
  ORDER_DASHBOARD = "ORDER_DASHBOARD", // "Dashboard bestellen"
  DASH_TAKEN_BY_CUSTOMER = "DASH_TAKEN_BY_CUSTOMER", // "Dash (klant al meegenomen)"
  LEAVE_DEFECTIVE_DASHBOARD = "LEAVE_DEFECTIVE_DASHBOARD", // "Defect dashboard achterlaten +25)"
  DASH_REP = "DASH_REP", // "Dash rep"
  STILL_TAKE_DASH = "STILL_TAKE_DASH", // "Dash nog meenemen"
  ADVANCE_PAYMENT = "ADVANCE_PAYMENT", // "voorschot"
}

export enum BIN_POSITION {
  UPPER_BACKSIDE = "UPPER-BACKSIDE",
  UPPER_FRONTSIDE = "UPPER-FRONTSIDE",
  LOWER_BACKSIDE = "LOWER-BACKSIDE",
  LOWER_FRONTSIDE = "LOWER-FRONTSIDE",
}

export interface Customer {
  id: number;
  customerNumber: string;
  email: string;
  firstName: string;
  lastName: string;
  type: CUSTOMER_TYPE;
  phone: string;
  vatNumber?: string;
  companyName?: string;
  country?: CountryCode;
  city: string;
  street: string;
  houseNumber: string;
  postcode: string;
  vip: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Order {
  id: string;
  friendlyId: string;
  customer?: Customer;
  deliveryMethod?: DELIVERY_METHOD;
  urgent: boolean;
  paymentStatus: PAYMENT_STATUS;
  paymentMethod: PAYMENT_METHOD | null;
  proforma: boolean;
  internal: boolean;
  brand: string;
  type?: ORDER_TYPE;
  guarantee: boolean;
  comment: string;
  internalComment: string;
  products: OrderProduct[];
  status: REPAIR_STATUS;
  startUnpackingAt: string;
  endUnpackingAt: string;
  startBookingAt: string;
  endBookingAt: string;
  createdAt: string;
  updatedAt: string;
  winfaktSalesId: number | null;
  overdueDays?: number;
  dash: ORDER_DASH_OPTION[] | null;
  dashAdvancePayment: number | null;
}

export interface CmsProduct {
  name: string;
  labels: number;
  print_double?: boolean; // print double amount of labels
  price: number;
  product_id?: string;
  kilo: number;
  image?: {
    url: string;
    alt?: string;
    copyright?: string;
    dimensions: {
      width: number;
      height: number;
    };
  };
  priority?: number | null; // for sort order in list or products
}

export interface LogData {
  message: string;
  timestamp: string;
  level: string;
  userAgent: string;
  data: any;
}

export interface Bin {
  id: number;
  name: string;
  category: string; // reknummer
  position: BIN_POSITION;
  content: number;
  orderId?: string;
  order?: Order;
  active: boolean;
}

export enum ORDER_BAG_STATUS {
  NONE = 'NONE',
  QUALITYCHECK_BIN_BAGS = 'QUALITYCHECK_BIN_BAGS',
}

export interface OrderBag {
  id: string;
  binId?: number;
  sequence: number | null;
  readyToSendAt?: string; // string with timestamp
  status: ORDER_BAG_STATUS;
}

export interface OrderProduct {
  id: number;
  binId?: number;
  sequence: number | null;
  name: string;
}

export const MESSAGE_TYPE = {
  ERROR: "error",
  INFO: "info",
} as const;

export type MESSAGE_TYPE = (typeof MESSAGE_TYPE)[keyof typeof MESSAGE_TYPE];

